var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.165039,
    y: 0.943359,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#33B4A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.618 33.7434L30.1635 26.9434H53.7125L52.167 33.7434H28.618Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.165 35.1133H58.165V50.3725H52.2093L51.7927 52.3725H58.165H60.165V50.3725V35.1133V33.1133H58.165H22.165H20.165V35.1133V50.3725V52.3725H22.165H26.1927L26.6093 50.3725H22.165V35.1133Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.595 55.3441L28.1784 47.7441H51.7354L50.1521 55.3441H26.595Z",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.765,
    y: 39.3441,
    width: 6,
    height: 1.2,
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutService4);
export default __webpack_public_path__ + "static/media/about-service-4.c048503981b38091bb2684cc3df558fe.svg";
export { ForwardRef as ReactComponent };